import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CircleAlert } from 'lucide-react';
import style from "./DeleteItemModal.module.scss"
import DeleteProduct from "../../../services/products/deleteProducts.js"
import { toast } from 'react-toastify';
import handleErrorToast from '../../../utils/handleErrorToasts.js';
import { useEffect } from 'react';
import ITEM_TOASTS from '../../../utils/constants/toastMesages/itemToastMessage.js';


/**
 * A reusable confirmation modal for deleting an item.
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.show - Controls the visibility of the modal
 * @param {Function} props.onHide - Callback function to close the modal
 * @param {Object} props.item - The item to be deleted
 * @param {string} props.item.name - The name of the item to be shown in the message
 * @returns {JSX.Element} A modal dialog for delete confirmation
 *
 * @example
 * <DeleteModal
 *   show={true}
 *   onHide={() => setShow(false)}
 *   item={{ name: "Pizza" }}
 * />
 *
 * @author Susovan
 */
function DeleteModal({onHide, show, item}) {

  // Api handler for deleting an item 
  const deleteItem = async () => {
    try {
      const res = await DeleteProduct(item._id);
      toast.success(ITEM_TOASTS.ITEM_DELETED);
      onHide()
    }
    catch (error) {
      toast.error(ITEM_TOASTS.ITEM_NOT_DELETED);
    }
  }

  // Only attach the listener when modal is open
  useEffect(() => {
    if (!show) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        deleteItem();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [show]);

    return (
        <Modal
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // dialogClassName={`${style.deleteWidth}`}
        centered
      >
        <Modal.Body className="d-flex flex-column align-items-center text-center">
          <h5 className="mb-3">Are you sure you want to delete this item?</h5>
      
          <div className="mb-4">
            <CircleAlert size={48} className="text-danger" />
          </div>
      
          <div className="d-flex justify-content-center gap-3">
            <Button variant="secondary" onClick={onHide}>No</Button>
            <Button variant="danger" onClick={deleteItem} >Yes</Button>
          </div>
        </Modal.Body>
      </Modal>
      
      );
}

export default DeleteModal